( ( document ) => {
	'use strict'

	const classNames = {
		expand: 'js-focus',
		module: 'mod-contacts',
	}

	const selector = {
		module: `.${classNames.module}`,
		toggle: `.${classNames.module} > [tabindex]`,
	}

	const onDomReady = () => {
		// listen to clicks on toggle
		Array.prototype.slice.apply( document.querySelectorAll( `${selector.module}` ) )
			.forEach( _ =>
				_.querySelector( `${selector.toggle}` )
					.addEventListener( 'click', onClick.bind( this, _ ) ) )
	}

	const onClick = ( el ) => {
		if ( el.classList.contains( classNames.expand ) ) {
			el.classList.remove( classNames.expand )
		} else {
			Array.prototype.slice.apply( document.querySelectorAll( `${selector.module}` ) )
				.forEach( _ => _.classList.remove( classNames.expand ) )
			el.classList.add( classNames.expand )
		}
	}

	document.addEventListener( 'DOMContentLoaded', onDomReady.bind( this ) )

} )( document )
